import * as Yup from 'yup';
// import PropTypes from 'prop-types';
import { useCallback, useEffect, useState, useRef } from 'react';
import { debounce } from 'lodash';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { Form, FormikProvider, useFormik } from 'formik';
// material
import { LoadingButton, MobileDatePicker } from '@material-ui/lab';
import { useTheme } from '@material-ui/core/styles';
import { experimentalStyled as styled } from '@material-ui/core/styles';
import {
  Box,
  Card,
  Grid,
  Stack,
  Switch,
  TextField,
  Typography,
  Link,
  FormHelperText,
  FormControlLabel,
  Button,
  Container,
  Autocomplete,
  IconButton,
  Divider,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  Chip,
  Radio,
  RadioGroup,
  FormControl,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@material-ui/core';

// utils
import { fData } from '../../../utils/formatNumber';
import fakeRequest from '../../../utils/fakeRequest';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs.js';
import Page from 'src/components/Page.js';
//
import Label from '../../Label';
import { UploadAvatar, UploadSingleFile } from '../../upload';
import { Link as RouterLink } from 'react-router-dom';
import countries from '../user/countries';
import moment from 'moment';
import axios from 'axios';
import {REST_API_END_POINT, UNITS} from '../../../constants/Defaultvalues';
import { Delete, KeyboardBackspaceOutlined, QrCodeScanner, Close } from '@material-ui/icons';
import Scrollbar from 'src/components/Scrollbar';
import QbLogo from 'src/assets/quickbookLogo-removebg-preview.png';
import { Html5QrcodeScanner } from 'html5-qrcode';

/* Original materials table headers (do not remove)
const VALUE = [
  { id: 0, value: 'Material ID' },
  { id: 1, value: 'Materials' },
  { id: 2, value: 'Unit Cost' },
  { id: 3, value: 'Stock' },
  { id: 4, value: 'Min value' },
  { id: 5, value: 'Max Value' },
  { id: 6, value: 'Quantity' },
  { id: 10, value: 'Conversion Unit' },
  { id: 11, value: 'Conversion Qty' },
  { id: 13, value: 'Conversion Unit Cost' },
  { id: 12, value: 'Total Unit Qty' },
  // { id: 9, value: 'Shipping Per Item' },
  { id: 7, value: 'Sub total' },
  { id: 8, value: '' }
];
*/
const VALUE = [
  { id: 'item', value: 'ITEM' },
  { id: 'desc', value: 'DESCRIPTION' },
  { id: 'qty_ordered', value: 'QTY ORDERED' },
  { id: 'unit_cost_hdr', value: 'UNIT COST' },
  { id: 'qty_rec', value: "QTY REC'D" },
  { id: 'delivered', value: 'DELIVERED' },
  { id: 'svc_name', value: 'SERVICE NAME' },
  { id: 'svc_cost', value: 'SERVICE COST' },
  { id: 'amount', value: 'AMOUNT' },
  { id: 8, value: '' }
];
/* Original stock catalog table headers (do not remove)
const VALUEStockCatalog = [
  { id: 0, value: 'Catalog ID' },
  { id: 1, value: 'Catalogs' },
  { id: 2, value: 'Unit Cost' },
  { id: 3, value: 'Stock' },
  { id: 6, value: 'Quantity' },
  // { id: 9, value: 'Shipping Per Item' },
  { id: 7, value: 'Sub total' },
  { id: 8, value: '' }
];
*/
const VALUEStockCatalog = [
  { id: 'item', value: 'ITEM' },
  { id: 'desc', value: 'DESCRIPTION' },
  { id: 'qty_ordered', value: 'QTY ORDERED' },
  { id: 'unit_cost_hdr', value: 'UNIT COST' },
  { id: 'qty_rec', value: "QTY REC'D" },
  { id: 'delivered', value: 'DELIVERED' },
  { id: 'svc_name', value: 'SERVICE NAME' },
  { id: 'svc_cost', value: 'SERVICE COST' },
  { id: 'amount', value: 'AMOUNT' },
  { id: 8, value: '' }
];

// Alphanumeric comparison helper function (natural sort)
function alphanumericCompare(str1, str2) {
  const normalize = (str) => {
    if (str === null || str === undefined) return '';
    // Strip leading and trailing quotes before comparison
    let normalized = str.toString().trim();
    // Remove leading and trailing quotes (both single and double)
    normalized = normalized.replace(/^["']+|["']+$/g, '');
    return normalized;
  };

  const a = normalize(str1);
  const b = normalize(str2);

  if (!a && !b) return 0;
  if (!a) return -1;
  if (!b) return 1;

  const getChunks = (str) => {
    const chunks = [];
    let currentChunk = '';
    let chunkType = null; // 'hash', 'otherSpecial', 'digit', or 'letter'

    for (let i = 0; i < str.length; i++) {
      const char = str[i];
      const isDigit = /\d/.test(char);
      const isLetter = /[a-zA-Z]/.test(char);
      const isHash = char === '#';
      const isOtherSpecial = !isDigit && !isLetter && !isHash;
      
      // Determine chunk type with priority: hash < otherSpecial < digit < letter
      let currentType;
      if (isHash) {
        currentType = 'hash';
      } else if (isOtherSpecial) {
        currentType = 'otherSpecial';
      } else if (isDigit) {
        currentType = 'digit';
      } else {
        currentType = 'letter';
      }

      if (i === 0) {
        chunkType = currentType;
        currentChunk = char;
      } else if (currentType === chunkType) {
        currentChunk += char;
      } else {
        chunks.push({
          value: chunkType === 'digit' ? parseInt(currentChunk, 10) : currentChunk.toLowerCase(),
          type: chunkType
        });
        currentChunk = char;
        chunkType = currentType;
      }
    }

    if (currentChunk) {
      chunks.push({
        value: chunkType === 'digit' ? parseInt(currentChunk, 10) : currentChunk.toLowerCase(),
        type: chunkType
      });
    }

    return chunks;
  };

  const chunksA = getChunks(a);
  const chunksB = getChunks(b);
  const len = Math.min(chunksA.length, chunksB.length);

  // Type priority: hash (0) < otherSpecial (1) < digit (2) < letter (3)
  const getTypePriority = (type) => {
    if (type === 'hash') return 0;
    if (type === 'otherSpecial') return 1;
    if (type === 'digit') return 2;
    return 3; // letter
  };

  for (let i = 0; i < len; i++) {
    const chunkA = chunksA[i];
    const chunkB = chunksB[i];

    const priorityA = getTypePriority(chunkA.type);
    const priorityB = getTypePriority(chunkB.type);

    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }

    // Same type, compare values
    if (chunkA.type === 'digit') {
      if (chunkA.value < chunkB.value) return -1;
      if (chunkA.value > chunkB.value) return 1;
    } else {
      if (chunkA.value < chunkB.value) return -1;
      if (chunkA.value > chunkB.value) return 1;
    }
  }

  if (chunksA.length < chunksB.length) return -1;
  if (chunksA.length > chunksB.length) return 1;

  return 0;
}

const selectInputValue = (event) => {
  const input = event.target;
  setTimeout(() => {
    if (input?.select) {
      input.select();
    }
  }, 0);
};

export default function CreateReceiveOrders() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme()
  const [vendors, setVendors] = useState([]);
  const [productsData, setProductsData] = useState([]);
  console.log('productsData....',productsData)
  const [serviceData, setServiceData] = useState([]);
  const [productsDatafilter, setProductsDatafilter] = useState([]);
  const currentDate = moment().format('MM-DD-YYYY');
  const [dataSetValue,setDataSetvalue] = useState({minVal:'',maxVal:''})
  const userData = JSON.parse(localStorage.getItem('user'))
  const userId = userData.user_id
  const userType = userData.user_type
  const [productRows, setProductRows] = useState([{ product: '', qty: '', unitCost: '', total: '' }]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [taxPercentage, setTaxPercentage] = useState(0);
  const [selectedTaxCategory,setSelectedTaxCategory]=  useState(null);
  const [taxCategories,setTaxCategories]=  useState([]);
 const [taxValue,setTaxValue] = useState(null)
 const [stockCatalogs,setStockCatalogs] = useState([])
 const [selectedStockCatalog,setSelectedStockCatalog] = useState([])
 const [selectedServices, setSelectedServices] = useState([])
 const [productType,setProductType] = useState('materials')
 const [renderService,setRenderService] = useState(false)
 const [openQRScanner, setOpenQRScanner] = useState(false);
 const [openCatalogQRScanner, setOpenCatalogQRScanner] = useState(false);
 const scannerRef = useRef(null);
 const catalogScannerRef = useRef(null);
const [searchMaterial, setSearchMaterial] = useState('');
  const [qrSearchDisplayName, setQrSearchDisplayName] = useState('');
  const [searchCatalog, setSearchCatalog] = useState('');
  const [qrCatalogSearchDisplayName, setQrCatalogSearchDisplayName] = useState('');
  const [openBackConfirm, setOpenBackConfirm] = useState(false);
  const [projectTypes,setProjectTypes] = useState([])
  const [isSalesOrderLoading, setIsSalesOrderLoading] = useState(false);
  const [salesOrders, setSalesOrders] = useState([]);
  const [selectedSalesOrder, setSelectedSalesOrder] = useState(null);
  console.log('salesOrders....',salesOrders)
  const MAX_CHARACTERS = 500;
  let totalAmount = 0;


  const fetchTaxCategory = async () => {
    try{
        const response = await axios.post(`${REST_API_END_POINT}product/get-tax-category`,{bringProjectTypes:true})
        if(response.data.status === 1){
            // Sort tax categories alphanumerically by name
            const sortedTaxCategories = [...(response.data.taxResult || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
            setTaxCategories(sortedTaxCategories);
            setProjectTypes(response.data.projectTypes)
        }else{
          setTaxCategories([])
        }
    }catch(error){
        console.log("Error - ",error);
        setTaxCategories([])
    }
  }

  const fetchSalesOrdersForAutocomplete = async (search = '') => {
    setIsSalesOrderLoading(true);
    try {
      const response = await axios.post(
        `${REST_API_END_POINT}product/get-sales-orders-for-autocomplete`,
        { userId, userType, search }
      );
      if (response.data.status === 1) {
        const rawSalesOrders = response.data.salesOrders || [];
        const sortedSalesOrders = [...rawSalesOrders].sort((a, b) =>
          alphanumericCompare(a?.name || '', b?.name || '')
        );
        setSalesOrders(sortedSalesOrders);
        console.log('sortedSalesOrders....',sortedSalesOrders)
      } else {
        setSalesOrders([]);
      }
    } catch (error) {
      console.log("Error fetching sales orders for autocomplete - ", error);
      setSalesOrders([]);
    } finally {
      setIsSalesOrderLoading(false);
    }
  }

  const debouncedFetchSalesOrders = useCallback(
    debounce((query) => {
      fetchSalesOrdersForAutocomplete(query);
    }, 500),
    []
  );;
  
  const handleback = () => {
    setOpenBackConfirm(true);
  };

  // Auto-save confirmation dialog handlers
  const handleBackConfirmYes = async () => {
    setOpenBackConfirm(false);
    try {
      await formik.submitForm();
    } catch (error) {
      console.error('Auto-save failed:', error);
      handleCancelAction();
    }
  };

  const handleBackConfirmNo = () => {
    setOpenBackConfirm(false);
    handleCancelAction();
  };

  const handleCancelAction = () => {
    navigate(PATH_DASHBOARD.receiveOrder.root);
  };
  const handleAddRow = () => {
    setProductRows([...productRows, { product: '', qty: '', unitCost: '', total: '' }]);
  };

  const handleDeleteRow = (id) => {
    setProductRows(productRows.filter((row,index) => index !== id));
  };

  // const handleProduct = (value) => {
  //   const productsWithQuantity = value.map((product) => ({
  //     ...product,
  //     quantity: selectedProducts.filter((p) => p.id === product.id)[0]?.quantity || 0,
  //     unitCost: selectedProducts.filter((p) => p.id === product.id)[0]?.unitCost || 0,     
  //   }));
  //   // console.log('productsWithQuantity*****',productsWithQuantity);
  //   setSelectedProducts(productsWithQuantity);
  // };

  const handleProduct = async (value) => {
    const productsWithQuantity = await Promise.all(value.map(async (product) => {
      const existing = selectedProducts.find((p) => p.id === product.id);
      
      // If vendor is selected and material doesn't have existing unitCost, fetch last unit cost
      let unitCost = existing?.unitCost || 0;
      if (values.vendor && !existing?.unitCost) {
        try {
          const response = await axios.post(
            `${REST_API_END_POINT}product/get-last-vendor-material-unit-cost`,
            {
              vendor_id: values.vendor,
              material_id: product.id
            }
          );
          if (response.data.status === 1 && response.data.unit_cost) {
            unitCost = response.data.unit_cost;
          }
        } catch (error) {
          console.error('Error fetching last unit cost:', error);
          // Keep unitCost as 0 if fetch fails
        }
      }
      
      return {
        ...product,
        quantity: existing?.quantity || 1,
        unitCost: unitCost,
        shipping_cost: existing?.shipping_cost || 0,
        services: existing?.services || null,
        convertion_unit: existing?.convertion_unit || 4,
        convertion_qty: existing?.convertion_qty || 1
      };
    }));
    setSelectedProducts(productsWithQuantity);
  };

  const handleStockCatalog = async (value) => {
    const stockCatalogsWithQuantity = await Promise.all(value.map(async (stockCatalog) => {
      const existing = selectedStockCatalog.find((p) => p.id === stockCatalog.id);
      
      // If vendor is selected and catalog doesn't have existing unitCost, fetch last unit cost
      let unitCost = existing?.unitCost || 0;
      if (values.vendor && !existing?.unitCost) {
        try {
          const response = await axios.post(
            `${REST_API_END_POINT}product/get-last-vendor-material-unit-cost`,
            {
              vendor_id: values.vendor,
              material_id: stockCatalog.id
            }
          );
          if (response.data.status === 1 && response.data.unit_cost) {
            unitCost = response.data.unit_cost;
          }
        } catch (error) {
          console.error('Error fetching last unit cost:', error);
          // Keep unitCost as 0 if fetch fails
        }
      }
      
      return {
        ...stockCatalog,
        quantity: existing?.quantity || 0,
        unitCost: unitCost,
        shipping_cost: existing?.shipping_cost || 0,
        services: existing?.services || null
      };
    }));
    setSelectedStockCatalog(stockCatalogsWithQuantity);
  };

  const handleService = (value) => {
    const servicesWithPrice = value.map((service) => {
      const existing = selectedServices.find((s) => s.id === service.id);
      return {
        ...service,
        total_cost: existing?.total_cost || service.total_cost || 0
      };
    });
    setSelectedServices(servicesWithPrice);
    
    // Calculate sub_total
    let newTotalAmount = 0;
    servicesWithPrice.forEach(service => {
      newTotalAmount += parseFloat(service?.total_cost || 0);
    });
    const fixedTotal = parseFloat(newTotalAmount).toFixed(2);
    setFieldValue('sub_total', Number(fixedTotal));
  };


  const calculateTotal = (price, quantity) => {
    const parsedPrice = parseFloat(price) || 0;
    const parsedQuantity = parseFloat(quantity) || 0;
    const subtotal = parsedPrice * parsedQuantity;
    return parseFloat(subtotal.toFixed(2));;
  };
  const calculateGrandTotal = (subtotal) => {
  const includeTax = values.includeTax === 1;
  // let taxAmount = 0;
  const taxAmount = selectedTaxCategory ? (selectedTaxCategory.type === 1 ? (subtotal * (selectedTaxCategory.value || 0) / 100) : (selectedTaxCategory.value || 0) ) : 0;
  // if (includeTax) {
  //   taxAmount = subtotal * taxPercentage / 100;
  // }
  return subtotal + taxAmount;
};

  const handleDeleteProduct = (productId,type) => {
    const isMaterial = type == 1;
    if (isMaterial) {
      const filteredProduct = selectedProducts.filter(data => data.id !== productId);
      setFieldValue('products', filteredProduct);
      setSelectedProducts(filteredProduct);
      
      let newTotalAmount = 0;
      filteredProduct.forEach(product => {
        const totalUnits = (parseFloat(product?.quantity || 0) * parseFloat(product?.convertion_qty || 1));
        const subtotal = (
          (parseFloat(product?.unitCost || 0) * parseFloat(product?.quantity || 0)) +
          // (parseFloat(product?.unitCost || 0) * totalUnits) +
          (parseFloat(product?.shipping_cost || 0) * parseFloat(product?.quantity || 0)) +
          parseFloat(product?.services?.total_cost || 0)
        );
        newTotalAmount += subtotal;
      });
      let fixedAmount = parseFloat(newTotalAmount).toFixed(2);
      setFieldValue('sub_total', Number(fixedAmount));
      setFieldValue('grand_total', calculateGrandTotal(fixedAmount));
    } else if (type == 0) {
      const filteredCatalog = selectedStockCatalog.filter(data => data.id !== productId);
      setFieldValue('stockCatalogs', filteredCatalog);
      setSelectedStockCatalog(filteredCatalog);
      
      let newTotalAmount = 0;
      filteredCatalog.forEach(catalog => {
        const subtotal = (
          (parseFloat(catalog?.unitCost || 0) * parseFloat(catalog?.quantity || 0)) +
          (parseFloat(catalog?.shipping_cost || 0) * parseFloat(catalog?.quantity || 0)) +
          parseFloat(catalog?.services?.total_cost || 0)
        );
        newTotalAmount += subtotal;
      });
      let fixedAmount = parseFloat(newTotalAmount).toFixed(2);
      setFieldValue('sub_total', Number(fixedAmount));
      setFieldValue('grand_total', calculateGrandTotal(fixedAmount));
    } else if (type == 2) {
      // Service deletion
      const filteredServices = selectedServices.filter(data => data.id !== productId);
      setFieldValue('services', filteredServices);
      setSelectedServices(filteredServices);
      
      let newTotalAmount = 0;
      filteredServices.forEach(service => {
        newTotalAmount += parseFloat(service?.total_cost || 0);
      });
      let fixedAmount = parseFloat(newTotalAmount).toFixed(2);
      setFieldValue('sub_total', Number(fixedAmount));
      setFieldValue('grand_total', calculateGrandTotal(fixedAmount));
    }
  };

  const LabelStyleHead = styled(Typography)(({ theme }) => ({
    ...theme.typography.h5,
    color: theme.palette.text.primary,
  }))
  
  const fetchVendors = async () => {
    try{
      const response = await axios.post(`${REST_API_END_POINT}clients/getAllClients`,{userId,userType,
        isVendor:1
      })
      if(response.data.status === 1){
        const vendors = response?.data?.customer;
        // Sort vendors alphanumerically by name
        const sortedVendors = [...(vendors || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
        setVendors(sortedVendors);
      }
    }
    catch(error){
      console.log("Error - ",error);
    }
  }
  // const fetchTaxCategory = async () => {
  //   try{
  //     const response = await axios.post(`${REST_API_END_POINT}product/get-tax-category`)
  //     if(response.data.status === 1){
  //       const tax = response.data.taxResult?.find((option) => option.name = 'tax')
  //       if(tax){
  //         setTaxPercentage(tax.value);
  //       }
  //       else{
  //         setTaxPercentage(0);
  //       }
  //     }
  //   }
  //   catch(error){
  //     console.log("Error - ",error);
  //   }
  // }
  const fetchProducts = async () => {
    try{
      const response = await axios.post(`${REST_API_END_POINT}product/get-all-materials`,{userId,userType,
        isVendor:1,bringStockCatalog:1})
      if(response.data.status === 1){
        // Sort products/materials alphanumerically by description (fallback to name)
        const sortedProducts = [...(response.data.results || [])].sort((a, b) => {
          const aValue = a?.description || a?.name || '';
          const bValue = b?.description || b?.name || '';
          return alphanumericCompare(aValue, bValue);
        })
        setProductsDatafilter(sortedProducts);
        // Sort services alphanumerically by description (fallback to name)
        const sortedServices = [...(response?.data?.allServices || [])].sort((a, b) => {
          const aValue = a?.description || a?.name || '';
          const bValue = b?.description || b?.name || '';
          return alphanumericCompare(aValue, bValue);
        })
        setServiceData(sortedServices)
        // Sort stock catalogs alphanumerically by description (fallback to name)
        const sortedStockCatalogs = [...(response?.data?.stockCatalogs || [])].sort((a, b) => {
          const aValue = a?.description || a?.name || '';
          const bValue = b?.description || b?.name || '';
          return alphanumericCompare(aValue, bValue);
        })
        setStockCatalogs(sortedStockCatalogs)
      }
    }
    catch(error){
      console.log("Error - ",error);
    }
  }

  useEffect(()=>{
    fetchVendors();
    fetchTaxCategory()
    fetchProducts()
  },[])


  const NewProductSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    vendor: Yup.string().required('Vendor name is required'),
    receivedDate: Yup.date(),
    expectedDate: Yup.date(),
    // transactionId: Yup.string().required('Transaction ID is required'),
    products:productType =="materials" && Yup.array().min(1,'Please select atleast one product'),
    stockCatalogs:productType =="stockCatalog" && Yup.array().min(1,'Please select atleast one catalog'),
    services:productType =="serviceOnly" && Yup.array().min(1,'Please select atleast one service'),
  });
  
  const LabelStyle = styled(Typography)(({ theme }) => ({
    ...theme.typography.subtitle2,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1)
  }));
  
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: '',
      vendor:'',
      transactionId:'',
      receivedDate:moment().format('YYYY-MM-DD'),
      expectedDate:moment().format('YYYY-MM-DD'),
      includeTax:0,
      products: [],
      tax: 0,
      sub_total:0,
      grand_total:0,
      taxCategory:null,
      stockCatalogs:[],
      services: [],
      orderType: 'materials',
      projectType : null,
      shipVia: '',
      notes: '',
      salesOrderId: null
    },
    validationSchema: NewProductSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors, setFieldError }) => {
      try {
        // console.log('selectedProducts---',selectedProducts);
        values.taxCategory= selectedTaxCategory?.id
        const hasErrors = selectedProducts.some(product => product.unitCost === 0 || product.quantity === 0 || !product.unitCost || !product.quantity);
        const hasErrorsInCatalog = selectedStockCatalog.some(product => product.unitCost === 0 || product.quantity === 0 || !product.unitCost || !product.quantity);
        const hasErrorsInServices = selectedServices.some(service => !service.total_cost || service.total_cost === 0 || parseFloat(service.total_cost) <= 0);
        if(hasErrors){
          enqueueSnackbar('Please enter valid Unit Cost and  Quantity for material', { variant: 'error' });
        }else if(hasErrorsInCatalog){
          enqueueSnackbar('Please enter valid Unit Cost and  Quantity for catalog', { variant: 'error' });
        }else if(hasErrorsInServices){
          enqueueSnackbar('Please enter valid price for all services', { variant: 'error' });
        }else{
          values.products = selectedProducts
          values.stockCatalogs = selectedStockCatalog
          values.services = selectedServices
          const response = await axios.post(`${REST_API_END_POINT}product/create-receive-order`,{values,userId,})
          if (response.data.status === 1) {
            enqueueSnackbar(`Order ${values['name']} created successfully`, { variant: 'success' });
          }
          else {
            enqueueSnackbar('Failed to create order', { variant: 'error' });
          }
          resetForm();
          setSubmitting(false);
          navigate(PATH_DASHBOARD.receiveOrder.root);
        }
      } catch (error) {
        console.error("Error : ", error);
        setSubmitting(false);
        setErrors(error);
      }
    }
  });

  const { errors, values, touched, handleSubmit, isSubmitting, setFieldValue, getFieldProps } = formik;

  const handleSearchMaterialByQR = useCallback(async (materialBarcode) => {
    try {
      if (!materialBarcode) return;

      const response = await axios.post(`${REST_API_END_POINT}product/search-finished-product-by-qr`, {
        barcode: materialBarcode,
        userId,
        userType,
        isMaterial: true
      });

      if (response.data.status === 1) {
        const productListData = response.data.results;
        if (productListData && productListData.length > 0) {
          // Get current formik values to avoid stale closure
          const currentValues = formik.values;
          
          // Filter products that match the vendor and are inhouse
          const filteredProducts = productListData.filter(product => {
            if (!currentValues.vendor) return true;
            const vendorIds = product?.vendor_id?.split(',').map(id => id.trim());
            return vendorIds?.includes(currentValues.vendor?.toString()) && product.inhouse == 1;
          });

          if (filteredProducts.length > 0) {
            // Auto-select the first matching material
            const materialToAdd = filteredProducts[0];
            const isAlreadySelected = selectedProducts.some(p => p.id === materialToAdd.id);
            
            if (!isAlreadySelected) {
              const newProducts = [...currentValues.products, materialToAdd];
              setFieldValue('products', newProducts);
              handleProduct(newProducts);
            }
            
            setQrSearchDisplayName(materialBarcode || '');
            enqueueSnackbar('Material found and added', { variant: 'success' });
          } else {
            enqueueSnackbar('Material not found for selected vendor', { variant: 'warning' });
          }
        } else {
          enqueueSnackbar('Material not found', { variant: 'warning' });
        }
      } else {
        enqueueSnackbar('Material not found', { variant: 'warning' });
      }
    } catch (error) {
      console.error("Error searching material by QR:", error);
      enqueueSnackbar('Error searching material', { variant: 'error' });
    }
  }, [formik, selectedProducts, setFieldValue, handleProduct, userId, userType, enqueueSnackbar]);

  useEffect(() => {
    if (openQRScanner) {
      setTimeout(() => {
        if (!scannerRef.current) {
          scannerRef.current = new Html5QrcodeScanner("reader", { fps: 10, qrbox: 250 });

          scannerRef.current.render(
            (decodedText) => {
              setSearchMaterial(decodedText);
              handleSearchMaterialByQR(decodedText);
              setOpenQRScanner(false);
            },
            (errorMessage) => {
              console.error("QR Scan Error:", errorMessage);
            }
          );
        }
      }, 500);
    }

    return () => {
      if (scannerRef.current) {
        scannerRef.current.clear();
        scannerRef.current = null;
      }
    };
  }, [openQRScanner, handleSearchMaterialByQR]);

  const handleSearchCatalogByQR = useCallback(async (catalogBarcode) => {
    try {
      if (!catalogBarcode) return;

      const response = await axios.post(`${REST_API_END_POINT}product/search-finished-product-by-qr`, {
        barcode: catalogBarcode,
        userId,
        userType,
        isMaterial: false
      });

      if (response.data.status === 1) {
        const catalogListData = response.data.results;
        if (catalogListData && catalogListData.length > 0) {
          // Get current formik values to avoid stale closure
          const currentValues = formik.values;
          
          // Filter catalogs that match the vendor
          const filteredCatalogs = catalogListData.filter(catalog => {
            if (!currentValues.vendor) return true;
            const vendorIds = catalog?.vendor_id?.split(',').map(id => id.trim());
            return vendorIds?.includes(currentValues.vendor?.toString());
          });

          if (filteredCatalogs.length > 0) {
            // Auto-select the first matching catalog
            const catalogToAdd = filteredCatalogs[0];
            const isAlreadySelected = selectedStockCatalog.some(c => c.id === catalogToAdd.id);
            
            if (!isAlreadySelected) {
              const newCatalogs = [...currentValues.stockCatalogs, catalogToAdd];
              setFieldValue('stockCatalogs', newCatalogs);
              handleStockCatalog(newCatalogs);
            }
            
            setQrCatalogSearchDisplayName(catalogBarcode || '');
            enqueueSnackbar('Catalog found and added', { variant: 'success' });
          } else {
            enqueueSnackbar('Catalog not found for selected vendor', { variant: 'warning' });
          }
        } else {
          enqueueSnackbar('Catalog not found', { variant: 'warning' });
        }
      } else {
        enqueueSnackbar('Catalog not found', { variant: 'warning' });
      }
    } catch (error) {
      console.error("Error searching catalog by QR:", error);
      enqueueSnackbar('Error searching catalog', { variant: 'error' });
    }
  }, [formik, selectedStockCatalog, setFieldValue, handleStockCatalog, userId, userType, enqueueSnackbar]);

  useEffect(() => {
    if (openCatalogQRScanner) {
      setTimeout(() => {
        if (!catalogScannerRef.current) {
          catalogScannerRef.current = new Html5QrcodeScanner("reader", { fps: 10, qrbox: 250 });

          catalogScannerRef.current.render(
            (decodedText) => {
              setSearchCatalog(decodedText);
              handleSearchCatalogByQR(decodedText);
              setOpenCatalogQRScanner(false);
            },
            (errorMessage) => {
              console.error("QR Scan Error:", errorMessage);
            }
          );
        }
      }, 500);
    }

    return () => {
      if (catalogScannerRef.current) {
        catalogScannerRef.current.clear();
        catalogScannerRef.current = null;
      }
    };
  }, [openCatalogQRScanner, handleSearchCatalogByQR]);

  useEffect(() => {
    fetchSalesOrdersForAutocomplete();
  }, []);

  const updateGrandTotal = () => {
    const subtotal = values.sub_total || 0;
    // const grandTotal = calculateGrandTotal(subtotal);
    // const grandTotal = parseFloat(calculateGrandTotal(subtotal).toFixed(2));
    const taxAmount = selectedTaxCategory 
    ? (selectedTaxCategory.type === 1 
        ? (values.sub_total * (selectedTaxCategory.value || 0) / 100) 
        : (selectedTaxCategory.value || 0)) 
    : 0;

const fixedTaxAmount = parseFloat(taxAmount).toFixed(2);

const subTotal = parseFloat(values.sub_total || 0).toFixed(2);
// const grandTotal = Number(subTotal) + Number(fixedTaxAmount);
const grandTotal = (Number(subTotal) + Number(fixedTaxAmount)).toFixed(2);
console.log('grandTotal 1-------------------',grandTotal)
console.log('grandTotal subTotal-------------------',subTotal)
setFieldValue('tax', fixedTaxAmount);
    setFieldValue('grand_total', grandTotal);
  };
  
  // Update grand total whenever sub_total changes
  useEffect(() => {
    updateGrandTotal();
  }, [values.sub_total,productType,renderService]);

  const handleSwitchChange = (event) => {
    const includeTax = event.target.checked;
    let taxAmount = 0;
    if (includeTax) {
      taxAmount = values.sub_total * taxPercentage / 100;
    }
    const grandTotal = values.sub_total + taxAmount;
    setFieldValue('includeTax', includeTax ? 1 : 0);
    setFieldValue('tax', includeTax ? taxPercentage : 0);
    setFieldValue('grand_total', grandTotal);
  };

  const handleTaxCategoryChange = (newValue)=>{
    const taxAmount = newValue ? (newValue.type === 1 ? (values.sub_total * (newValue.value || 0) / 100) : (newValue.value || 0) ) : 0;
    let fixedAmount =parseFloat(taxAmount).toFixed(2)

    setFieldValue('tax', fixedAmount);
    let subTotal =parseFloat(values.sub_total).toFixed(2)
      
    // const grandTotal = Number(subTotal) + Number(fixedAmount)
    const grandTotal = (Number(subTotal) + Number(fixedAmount)).toFixed(2);
    setFieldValue('grand_total', grandTotal);
    console.log('dataaaaaaaaaaaaaaaaaaaaaaaaa',subTotal,fixedAmount,grandTotal)
  }


  const handleVendorChange = async (event, newValue) => {  
    if(newValue){
      setSelectedProducts([]);
      setFieldValue('products', []);
      setFieldValue('sub_total', 0);
      setFieldValue('grand_total', 0);
      setFieldValue('tax', 0);
      const selectedOption = vendors?.find(option => option.id === newValue.id)
      if(selectedOption){
      setFieldValue('vendor', newValue?.id);
      const newFilteredProductsOne = productsDatafilter.filter(product => {
        const vendorIds = product?.vendor_id?.split(',').map(id => id.trim()) || [];
        const secondaryVendorIds = product?.secondary_vendor_id?.split(',').map(id => id.trim()) || [];
        const vendorIdStr = newValue?.id?.toString();
        return vendorIds?.includes(vendorIdStr) || secondaryVendorIds?.includes(vendorIdStr);
      });
      const newFilteredProducts = newFilteredProductsOne?.filter(item=>item.inhouse == 1)
      // Sort filtered products alphanumerically by description (fallback to name)
      const sortedFilteredProducts = [...(newFilteredProducts || [])].sort((a, b) => {
        const aValue = a?.description || a?.name || '';
        const bValue = b?.description || b?.name || '';
        return alphanumericCompare(aValue, bValue);
      })
      console.log("Filtered Products:", sortedFilteredProducts);
      setProductsData(sortedFilteredProducts);

      }else {
      setFieldValue('vendor', '');
      }
  }
  else {
      setFieldValue('vendor', '')
  }
  };

  // Browser back button interception for auto-save
  useEffect(() => {
    const handlePopState = () => {
      setOpenBackConfirm(true);
      window.history.pushState(null, '', window.location.href);
    };
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  return (
    <Page title="Create Orders | Sign-Wise Solution">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <HeaderBreadcrumbs heading=" Create Orders" />  
          <Button
            variant="outlined"
            type="submit"
            onClick={handleback}
            sx={{ alignItems: 'right' }}
            startIcon={
              <Stack>
                <KeyboardBackspaceOutlined />
              </Stack>
            }
          >
            Back
          </Button>
        </Stack>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container spacing={3} justifyContent="center" alignItems="center">
              <Grid item xs={12} md={11}>
                <Card sx={{ p: 8, margin: 'auto',height: 'fit-content' }}>
                  <Stack spacing={3}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      <TextField
                          fullWidth
                          label="Name"
                          type="text"
                          {...getFieldProps('name')}
                          error={Boolean(touched.name && errors.name)}
                          helperText={touched.name && errors.name}
                      />
                      <Autocomplete
                          select
                          fullWidth
                          id="vendor"
                          options={vendors}
                          getOptionLabel={(option) => option.name}
                          value = {vendors?.find((option) => option.id === values.vendor) || null}
                          onChange={handleVendorChange}
                          renderOption={(props, option) => (
                            <li {...props}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                {option.syncWithQuickBook === 1 ? (
                                  <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                                ) : (
                                  <Avatar  sx={{ width: 30, height: 30, objectFit: "cover"}}/>
                                )}
                                <span>{option.name}</span>
                              </Box>
                            </li>
                          )}
                          renderInput={(params) => (
                          <TextField
                              {...params}
                              label="Select vendor"
                              fullWidth
                              SelectProps={{ native: true }}
                              error={Boolean(touched.vendor && errors.vendor)}
                              helperText={touched.vendor && errors.vendor}
                          />
                          )}
                      />
                    </Stack>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      <Autocomplete
                        fullWidth
                        options={salesOrders}
                        loading={isSalesOrderLoading}
                        getOptionLabel={(option) => option?.name ? `${option.name}` : ''}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason === 'input' || reason === 'clear') {
                            debouncedFetchSalesOrders(newInputValue);
                          }
                        }}
                        filterOptions={(options) => options} // Deactivate local filtering as search is done on server
                        isOptionEqualToValue={(option, value) => option.id === value?.id}
                        value={selectedSalesOrder}
                        onChange={(event, newValue) => {
                          setSelectedSalesOrder(newValue);
                          setFieldValue('salesOrderId', newValue ? newValue.id : null);
                        }}
                        renderOption={(props, option) => (
                          <li {...props} key={option.id}>
                            {option.name}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select sales order"
                            fullWidth
                          />
                        )}
                      />
                    </Stack>
                    {/* <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                    <TextField
                        fullWidth
                        label="Transaction ID"
                        {...getFieldProps('transactionId')}
                        error={Boolean(touched.transactionId && errors.transactionId)}
                        helperText={touched.transactionId && errors.transactionId}
                    />
                    </Stack> */}
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      <Box
                        component={MobileDatePicker}
                        label="Date Received"
                        maxDate={currentDate}
                        value={values.receivedDate}
                        onChange={(date) => setFieldValue('receivedDate', date)}
                        renderInput={(params) => (
                          <TextField size="medium" {...params} fullWidth />
                        )}
                      />
                      <Box
                        component={MobileDatePicker}
                        label="Date Expected"
                        minDate={currentDate}
                        value={values.expectedDate}
                        onChange={(date) => setFieldValue('expectedDate', date)}
                        renderInput={(params) => (
                          <TextField size="medium" {...params} fullWidth />
                        )}
                      />
                    </Stack>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      <TextField
                        fullWidth
                        label="Ship Via"
                        type="text"
                        {...getFieldProps('shipVia')}
                        error={Boolean(touched.shipVia && errors.shipVia)}
                        helperText={touched.shipVia && errors.shipVia}
                      />
                    </Stack>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      <Autocomplete
                        fullWidth
                        options={projectTypes}
                        getOptionLabel={(option) => option.name}
                        value={values.projectType}
                        onChange={(event, newValue) => setFieldValue('projectType', newValue)}
                        renderInput={(params) => (
                          <TextField {...params} label="Classification" fullWidth />
                        )}
                      />
                    </Stack>
                    <LabelStyle>Notes</LabelStyle>
                  
                    <TextField
                      fullWidth
                      multiline
                      minRows={3}
                      maxRows={7}
                      label="Notes"
                    {...getFieldProps('notes')}
                    error={Boolean(touched.notes && errors.notes)}
                      helperText={
                    touched.notes && errors.notes
                    ? errors.notes
                      : `${values.notes?.length || 0}/${MAX_CHARACTERS} characters`
                      }
                     inputProps={{
                         maxLength: MAX_CHARACTERS,
                    }}
                     InputProps={{
                     sx: {
                    color: 'error.main',
                       }
                             }}
                    />
                    <Divider />
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      <FormControl component="fieldset">
                        <RadioGroup
                          row
                          value={values.orderType}
                          onChange={(event) => {
                            setFieldValue('orderType', event.target.value)
                            setFieldValue('sub_total', 0)
                            setFieldValue('tax', 0);
                            setSelectedTaxCategory(null);
                            setFieldValue('grand_total', 0);
                            setProductType(event.target.value)
                            if(event.target.value === 'materials'){
                              setFieldValue('stockCatalogs', []);
                              setSelectedStockCatalog([])
                              setFieldValue('services', []);
                              setSelectedServices([])
                            }else if(event.target.value === 'stockCatalog'){
                              setFieldValue('products', [])
                              setSelectedProducts([])
                              setFieldValue('services', []);
                              setSelectedServices([])
                            }else if(event.target.value === 'serviceOnly'){
                              setFieldValue('products', [])
                              setSelectedProducts([])
                              setFieldValue('stockCatalogs', []);
                              setSelectedStockCatalog([])
                            }
                          }}
                        >
                          <FormControlLabel
                            value="materials"
                            control={<Radio color="primary" />}
                            label="MATERIALS"
                          />
                          <FormControlLabel
                            value="stockCatalog"
                            control={<Radio color="primary" />}
                            label="STOCK CATALOGS"
                          />
                          <FormControlLabel
                            value="serviceOnly"
                            control={<Radio color="primary" />}
                            label="SERVICE ONLY"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Stack>
                    <Divider />
                    {
                      productType == "materials" && (
                        <>
                    <LabelStyleHead>Materials</LabelStyleHead>
                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      {                            console.log("values.products",values.products)}
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, width: '100%' }}>
                          <Autocomplete
                            fullWidth
                            multiple
                            id="combo-box-demo"
                            // options={productsData || []}
                            options={productsData?.filter(product => !selectedProducts.some(selected => selected.id === product.id)) || []}
                            value={values.products}
                            onChange={async (event, newValue) => {
                              if (!newValue || newValue.length === 0) {
                                setFieldValue('products', newValue);
                                setSelectedProducts([]);
                                setFieldValue('sub_total', 0);
                                setFieldValue('grand_total', 0);
                                setSearchMaterial('');
                                setQrSearchDisplayName('');
                              } else {
                                setFieldValue('products', newValue);
                                await handleProduct(newValue);
                              }
                            }}
                            // getOptionLabel={(option) => option.name ? option.name : ''}
                            // getOptionSelected={(option, value) => option.id === value.id}
                            // renderInput={(params) => (
                            //   <TextField {...params} required fullWidth
                            //   error={Boolean(touched.products && errors.products)}
                            //   helperText={touched.products && errors.products} 
                            //   label="Select material" />
                            // )}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            getOptionLabel={(option) => {
                              const name = option.name || '';
                              const description = option.description || '';
                              return `${description} \u200B${name}`.trim(); // combines both for search
                            }}
                            renderOption={(props, option) => {
                              const { style, ...liProps } = props;
                              const description = option.description || '';
                              return (
                                <li
                                  {...liProps}
                                  style={{
                                    ...style,
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  {option.syncWithQuickbooks === 1 && (
                                    <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover", mr: 1 }}/>
                                  )}
                                  <Tooltip title={description}>
                                    <span style={{
                                      flex: 1,
                                      minWidth: 0,
                                      display: 'block',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                    }}>
                                      {description}
                                    </span>
                                  </Tooltip>
                                  <span style={{ display: 'none' }}>{option.name}</span>
                                </li>
                              );
                            }}
                            renderTags={(value, getTagProps) =>
                              value.map((option, index) => {
                                const tooltipText = `${option.description || ''}`;
                                return (
                                  <Tooltip key={index} title={tooltipText}>
                                    <Chip
                                      {...getTagProps({ index })}
                                      label={option.description || ''}
                                    />
                                  </Tooltip>
                                );
                              })
                            }
                            filterOptions={(options, { inputValue }) =>
                              options.filter((option) => {
                                const searchText = inputValue.toLowerCase();
                                return (
                                  option.name?.toLowerCase().includes(searchText) ||
                                  option.description?.toLowerCase().includes(searchText)
                                );
                              })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                required
                                fullWidth
                                error={Boolean(touched.products && errors.products)}
                                helperText={touched.products && errors.products}
                                label="Select material"
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      <Tooltip title="Scan QR Code">
                                        <IconButton
                                          size="small"
                                          onClick={() => setOpenQRScanner(true)}
                                          sx={{ mr: 1 }}
                                        >
                                          <QrCodeScanner />
                                        </IconButton>
                                      </Tooltip>
                                      {params.InputProps.endAdornment}
                                    </>
                                  )
                                }}
                              />
                            )}
                          />
                          <Dialog open={openQRScanner} onClose={() => setOpenQRScanner(false)}>
                            <DialogTitle>Scan QR Code</DialogTitle>
                            <DialogContent>
                              <div id="reader" style={{ width: "100%" }}></div>
                            </DialogContent>
                          </Dialog>
                        </Box>
                      </Stack>    
                      </>
                        )
                      }         
                      {(selectedProducts?.length > 0) &&
                      <>
                        <LabelStyle>Selected Materials</LabelStyle>
                        <Scrollbar>
                          <TableContainer sx={{ minWidth: 800 }}>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  {VALUE?.map((val) => (
                                    <TableCell key={val.id}>{val.value}</TableCell>
                                  ))}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {selectedProducts?.map((data, index) => {
                                  const quantityFieldName = `quantity_${index}`;
                                  const unitCostFieldName = `unitCost_${index}`;
                                  const shippingFieldName = `shipping_cost_${index}`;
                                  const convertionUnitFieldName = `convertion_unit_${index}`;
                                  const convertionQtyFieldName = `convertion_qty_${index}`;
                                  
                                  const totalUnitQty = (parseFloat(data?.quantity || 0) * parseFloat(data?.convertion_qty || 1));
                                  // const rowTotal = calculateTotal(values[unitCostFieldName], values[quantityFieldName]);
                                  const rowTotal = (
                                  (parseFloat(data?.unitCost || 0) * parseFloat(data?.quantity || 0)) +
                                  // (parseFloat(data?.unitCost || 0) * totalUnitQty) +
                                  (parseFloat(data?.shipping_cost || 0) * parseFloat(data?.quantity || 0)) +
                                  parseFloat(data?.services?.total_cost || 0)
                                ).toFixed(2);
                                  // Accumulate the totalAmount
                                  totalAmount += Number(rowTotal);
                                  const fixedTotal = parseFloat(totalAmount).toFixed(2);
                                  // setFieldValue('sub_total', fixedTotal);
                                  values['sub_total'] = fixedTotal
                                  console.log(data,'-----------data')
                                  return (
                                    <>
                                    <TableRow key={data.id}>
                                      <TableCell sx={{ maxWidth: 200, wordBreak: 'break-word', verticalAlign: 'top' }}>
                                        {data.name || ''}
                                      </TableCell>
                                      <TableCell sx={{ maxWidth: 280, wordBreak: 'break-word', verticalAlign: 'top' }}>
                                        {data.description || ''}
                                      </TableCell>
                                      <TableCell>
                                        <TextField required
                                          fullWidth
                                          type='number'
                                          label="QTY ORDERED"
                                          value={data.quantity || ''}
                                          onWheel={(e) => e.target.blur()}
                                          onKeyPress={(event) => {
                                            if (event.key === '0' && event.target.value === '0' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '0' && event.target.value === '' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '.' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '-' ) {
                                              event.preventDefault();
                                            }
                                          }}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (newValue !== "0" && newValue !== "") {
                                              if (newValue.startsWith('-')) {
                                                newValue = newValue.slice(1);
                                              }
                                              data['quantity'] = newValue || 0;
                                              setFieldValue(quantityFieldName, newValue);
                                              let newTotalAmount = 0;
                                              selectedProducts.forEach(product => {
                                                const totalUnits = (parseFloat(product?.quantity || 0) * parseFloat(product?.convertion_qty || 1));
                                                const subtotal = (
                                                  (parseFloat(product?.unitCost || 0) * parseFloat(product?.quantity || 0)) +
                                                  (parseFloat(product?.shipping_cost || 0) * parseFloat(product?.quantity || 0)) +
                                                  parseFloat(product?.services?.total_cost || 0)
                                                );
                                                newTotalAmount += subtotal;
                                              });
                                              setFieldValue('sub_total', parseFloat(newTotalAmount).toFixed(2));
                                            }
                                          }}
                                          error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                          helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <TextField required
                                          fullWidth
                                          type='number'
                                          label="UNIT COST"
                                          sx={{width:"100px"}}
                                          value={data.unitCost || ''}
                                          onKeyPress={(event) => {
                                            if (event.key === '0' && event.target.value === '0' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '0' && event.target.value === '' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '-' ) {
                                              event.preventDefault();
                                            }
                                          }}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (newValue !== "0" && newValue !== "") {
                                              if (newValue.includes('.')) {
                                                const parts = newValue.split('.');
                                                if (parts[1].length > 2) {
                                                    newValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
                                                }
                                            }
                                              data['unitCost'] = newValue || 0;
                                              setFieldValue(unitCostFieldName, newValue);
                                              let newTotalAmount = 0;
                                              selectedProducts.forEach(product => {
                                                const totalUnits = (parseFloat(product?.quantity || 0) * parseFloat(product?.convertion_qty || 1));
                                                const subtotal = (
                                                  (parseFloat(product?.unitCost || 0) * parseFloat(product?.quantity || 0)) +
                                                  (parseFloat(product?.shipping_cost || 0) * parseFloat(product?.quantity || 0)) +
                                                  parseFloat(product?.services?.total_cost || 0)
                                                );
                                                newTotalAmount += subtotal;
                                              });
                                              setFieldValue('sub_total', parseFloat(newTotalAmount).toFixed(2));
                                            }
                                          }}
                                          error={Boolean(touched[unitCostFieldName] && errors[unitCostFieldName])}
                                          helperText={touched[unitCostFieldName] && errors[unitCostFieldName]}
                                        />
                                      </TableCell>
                                      <TableCell align="center">-</TableCell>
                                      <TableCell align="center">-</TableCell>
                                      <TableCell sx={{ minWidth: 250 }}>
                                        <Autocomplete
                                          fullWidth
                                          id={`sub-material-autocomplete-${data.id}`}
                                          options={
                                            [...(serviceData || [])].sort((a, b) => {
                                              const aValue = a?.description || a?.name || '';
                                              const bValue = b?.description || b?.name || '';
                                              return alphanumericCompare(aValue, bValue);
                                            })
                                          }
                                          value={data.services || null}
                                          onChange={(e, newValue) => {
                                            const updatedProducts = [...selectedProducts];
                                            updatedProducts[index].services = newValue;
                                            setSelectedProducts(updatedProducts);
                                            setRenderService(!renderService);
                                            let newTotalAmount = 0;
                                            updatedProducts.forEach(product => {
                                              const totalUnits = (parseFloat(product?.quantity || 0) * parseFloat(product?.convertion_qty || 1));
                                              const subtotal = (
                                                (parseFloat(product?.unitCost || 0) * parseFloat(product?.quantity || 0)) +
                                                (parseFloat(product?.shipping_cost || 0) * parseFloat(product?.quantity || 0)) +
                                                parseFloat(product?.services?.total_cost || 0)
                                              );
                                              newTotalAmount += subtotal;
                                            });
                                            setFieldValue('sub_total', parseFloat(newTotalAmount).toFixed(2));
                                          }}
                                          getOptionLabel={(option) => `${option.description || ''} ${option.name || ''}`.trim()}
                                          renderOption={(props, option) => (
                                            <li {...props}>
                                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                {option.syncWithQuickbooks == 1 && (
                                                  <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                                                )}
                                                <span>{`${option.description || ''} ${option.name || ''}`.trim()}</span>
                                              </Box>
                                            </li>
                                          )}
                                          renderInput={(params) => (
                                            <TextField {...params} label="Select Service (optional)" required fullWidth />
                                          )}
                                        />
                                      </TableCell>
                                      <TableCell sx={{ width: 112, maxWidth: 120, verticalAlign: 'middle' }}>
                                        {data.services ? (
                                          <TextField
                                            type='number'
                                            label="Service Cost"
                                            sx={{ width: 104, maxWidth: 110 }}
                                            value={data.services.total_cost || ''}
                                            onWheel={(e) => e.target.blur()}
                                            onKeyPress={(event) => {
                                              if (event.key === '0' && event.target.value === '0') {
                                                event.preventDefault();
                                              }
                                              if (event.key === '0' && event.target.value === '') {
                                                event.preventDefault();
                                              }
                                              if (event.key === '-') {
                                                event.preventDefault();
                                              }
                                            }}
                                            onKeyDown={(event) => {
                                              if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                                const newValue = event.target.value || 0;
                                                if (newValue < 1 && event.key === 'ArrowDown') {
                                                  event.preventDefault();
                                                }
                                              }
                                            }}
                                            onChange={(event) => {
                                              let newValue = event.target.value;
                                              if (newValue === "" || newValue === "0") {
                                                newValue = "0";
                                              } else {
                                                if (newValue.includes('.')) {
                                                  const parts = newValue.split('.');
                                                  if (parts[1].length > 2) {
                                                    newValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
                                                  }
                                                }
                                              }
                                              const updatedProducts = [...selectedProducts];
                                              if (updatedProducts[index].services) {
                                                updatedProducts[index].services.total_cost = newValue || 0;
                                              }
                                              setSelectedProducts(updatedProducts);
                                              let newTotalAmount = 0;
                                              updatedProducts.forEach(product => {
                                                const totalUnits = (parseFloat(product?.quantity || 0) * parseFloat(product?.convertion_qty || 1));
                                                const subtotal = (
                                                  (parseFloat(product?.unitCost || 0) * parseFloat(product?.quantity || 0)) +
                                                  (parseFloat(product?.shipping_cost || 0) * parseFloat(product?.quantity || 0)) +
                                                  parseFloat(product?.services?.total_cost || 0)
                                                );
                                                newTotalAmount += subtotal;
                                              });
                                              const fixedTotal = parseFloat(newTotalAmount).toFixed(2);
                                              setFieldValue('sub_total', Number(fixedTotal));
                                            }}
                                          />
                                        ) : (
                                          <Typography variant='body1'>No service selected</Typography>
                                        )}
                                      </TableCell>
                                      <TableCell>
                                        {rowTotal}
                                      </TableCell>
                                      <TableCell>
                                        <IconButton onClick={() => handleDeleteProduct(data.id,1)}>
                                          <Delete />
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>
                                    {/* Previous materials table (full-width row + service sub-row). Disabled — remove `false &&` to render again. */}
                                    {false && (
                                    <>
                                    <TableRow key={`legacy-material-row-${data.id}`}>
                                      <TableCell>{data.id}</TableCell>
                                      <TableCell>{data.name}</TableCell>
                                      <TableCell>
                                        <TextField required
                                          fullWidth
                                          type='number'
                                          label="Unit Cost"
                                          sx={{width:"100px"}}
                                          value={data.unitCost || ''}
                                          onFocus={selectInputValue}
                                          onClick={selectInputValue}
                                          onKeyPress={(event) => {
                                            // console.log('errorFieldId------',errorFieldId)
                                            if (event.key === '0' && event.target.value === '0' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '0' && event.target.value === '' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '-' ) {
                                              event.preventDefault();
                                            }
                                          }}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (newValue !== "0" && newValue !== "") {

                                              if (newValue.includes('.')) {
                                                const parts = newValue.split('.');
                                                if (parts[1].length > 2) {
                                                    newValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
                                                }
                                            }

                                              data['unitCost'] = newValue || 0;
                                              setFieldValue(unitCostFieldName, newValue);

                                              // Force sub_total update
                                              let newTotalAmount = 0;
                                              selectedProducts.forEach(product => {
                                                const totalUnits = (parseFloat(product?.quantity || 0) * parseFloat(product?.convertion_qty || 1));
                                                const subtotal = (
                                                  (parseFloat(product?.unitCost || 0) * parseFloat(product?.quantity || 0)) +
                                                  // (parseFloat(product?.unitCost || 0) * totalUnits) +
                                                  (parseFloat(product?.shipping_cost || 0) * parseFloat(product?.quantity || 0)) +
                                                  parseFloat(product?.services?.total_cost || 0)
                                                );
                                                newTotalAmount += subtotal;
                                              });
                                              setFieldValue('sub_total', parseFloat(newTotalAmount).toFixed(2));
                                            }
                                          
                                          }}
                                          error={Boolean(touched[unitCostFieldName] && errors[unitCostFieldName])}
                                          helperText={touched[unitCostFieldName] && errors[unitCostFieldName]}
                                        />
                                      </TableCell>
                                        <TableCell align='center'>{data.total_qty}</TableCell> 
                                        <TableCell align='center'>{data.min_value}</TableCell> 
                                        <TableCell align='center'>{data.max_value}</TableCell> 
                                      <TableCell>
                                        <TextField required
                                          fullWidth
                                          type='number'
                                          label="Quantity"
                                          // value={Number(data.quantity)}
                                          value={data.quantity || ''}
                                          onWheel={(e) => e.target.blur()}
                                          onFocus={selectInputValue}
                                          onClick={selectInputValue}
                                          onKeyPress={(event) => {
                                            // console.log('errorFieldId------',errorFieldId)
                                            if (event.key === '0' && event.target.value === '0' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '0' && event.target.value === '' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '.' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '-' ) {
                                              event.preventDefault();
                                            }
                                          }}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (newValue !== "0" && newValue !== "") {
                                              // if (newValue === '' || newValue <= 0) {
                                              //   event.preventDefault();
                                              //   return;
                                              // }
                                              if (newValue.startsWith('-')) {
                                                newValue = newValue.slice(1);
                                              }
                                              data['quantity'] = newValue || 0;
                                              setFieldValue(quantityFieldName, newValue);
                                              
                                              // Force sub_total update
                                              let newTotalAmount = 0;
                                              selectedProducts.forEach(product => {
                                                const totalUnits = (parseFloat(product?.quantity || 0) * parseFloat(product?.convertion_qty || 1));
                                                const subtotal = (
                                                  (parseFloat(product?.unitCost || 0) * parseFloat(product?.quantity || 0)) +
                                                  // (parseFloat(product?.unitCost || 0) * totalUnits) +
                                                  (parseFloat(product?.shipping_cost || 0) * parseFloat(product?.quantity || 0)) +
                                                  parseFloat(product?.services?.total_cost || 0)
                                                );
                                                newTotalAmount += subtotal;
                                              });
                                              setFieldValue('sub_total', parseFloat(newTotalAmount).toFixed(2));
                                            }
                                          }}
                                          error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                          helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <Autocomplete
                                          fullWidth
                                          options={UNITS}
                                          value={UNITS?.find(u => u.id === data.convertion_unit) || 4}
                                          onChange={(event, newValue) => {
                                            const updatedProducts = [...selectedProducts];
                                            updatedProducts[index].convertion_unit = newValue?.id || 4;
                                            if (newValue?.id === 4 || newValue?.name === 'Unit') {
                                              updatedProducts[index].convertion_qty = 1;
                                            }
                                            setSelectedProducts(updatedProducts);
                                            setFieldValue(convertionUnitFieldName, newValue);
                                            
                                            // Recalculate sub_total
                                            let newTotalAmount = 0;
                                            updatedProducts.forEach(product => {
                                              const totalUnits = (parseFloat(product?.quantity || 0) * parseFloat(product?.convertion_qty || 1));
                                              const subtotal = (
                                                (parseFloat(product?.unitCost || 0) * parseFloat(product?.quantity || 0)) +
                                                // (parseFloat(product?.unitCost || 0) * totalUnits) +
                                                (parseFloat(product?.shipping_cost || 0) * parseFloat(product?.quantity || 0)) +
                                                parseFloat(product?.services?.total_cost || 0)
                                              );
                                              newTotalAmount += subtotal;
                                            });
                                            setFieldValue('sub_total', parseFloat(newTotalAmount).toFixed(2));
                                          }}
                                          renderInput={(params) => <TextField {...params} label="Unit" sx={{width:"120px"}} />}
                                          getOptionLabel={(option) => option?.name || ''}
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <TextField
                                          fullWidth
                                          type="number"
                                          label="Conv Qty"
                                          sx={{width:"80px"}}
                                          disabled={data.convertion_unit === 4}
                                          value={data.convertion_qty || ''}
                                          onFocus={selectInputValue}
                                          onClick={selectInputValue}
                                          onKeyPress={(event) => {
                                            if (event.key === '-' || event.key === '+' || event.key === 'e' || event.key === 'E') {
                                              event.preventDefault();
                                            }
                                          }}
                                          onChange={(e) => {
                                            let newValue = e.target.value;
                                            const updatedProducts = [...selectedProducts];
                                            updatedProducts[index].convertion_qty = newValue || 1;
                                            setSelectedProducts(updatedProducts);
                                            setFieldValue(convertionQtyFieldName, newValue);
                                            
                                            // Recalculate sub_total
                                            let newTotalAmount = 0;
                                            updatedProducts.forEach(product => {
                                              const totalUnits = (parseFloat(product?.quantity || 0) * parseFloat(product?.convertion_qty || 1));
                                              const subtotal = (
                                                (parseFloat(product?.unitCost || 0) * totalUnits) +
                                                (parseFloat(product?.shipping_cost || 0) * parseFloat(product?.quantity || 0)) +
                                                parseFloat(product?.services?.total_cost || 0)
                                              );
                                              newTotalAmount += subtotal;
                                            });
                                            setFieldValue('sub_total', parseFloat(newTotalAmount).toFixed(2));
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell align='center'>
                                        {(parseFloat(data.unitCost || 0) / parseFloat(data.convertion_qty || 1)).toFixed(2)}
                                      </TableCell>
                                      <TableCell align='center'>
                                        {(parseFloat(data.quantity || 0) * parseFloat(data.convertion_qty || 1)).toFixed(2)}
                                      </TableCell>
                                      {/* <TableCell>
                                        <TextField required
                                          fullWidth
                                          type='number'
                                          label="Shipping"
                                          value={data?.shipping_cost || ''}
                                          onWheel={(e) => e.target.blur()}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (newValue !== "0" && newValue !== "") {
                                              if (newValue.startsWith('-')) {
                                                newValue = newValue.slice(1);
                                              }
                                              data['shipping_cost'] = newValue || 0;
                                              setFieldValue(shippingFieldName, newValue);
                                            }
                                          }}
                                          error={Boolean(touched[shippingFieldName] && errors[shippingFieldName])}
                                          helperText={touched[shippingFieldName] && errors[shippingFieldName]}
                                        />
                                      </TableCell> */}
                                      <TableCell> 
                                        {rowTotal}
                                        {/* {calculateTotal(values[unitCostFieldName], values[quantityFieldName])} */}
                                      </TableCell>
                                      <TableCell >
                                        <IconButton onClick={() => handleDeleteProduct(data.id,1)}>
                                          <Delete />
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>
                                    <TableRow key={`sub-material-${data.id}`}>
                                        <TableCell colSpan={3}>
                                          <Autocomplete
                                            fullWidth
                                            id={`sub-material-autocomplete-legacy-${data.id}`}
                                            options={
                                              [...(serviceData || [])].sort((a, b) => {
                                                const aValue = a?.description || a?.name || '';
                                                const bValue = b?.description || b?.name || '';
                                                return alphanumericCompare(aValue, bValue);
                                              })
                                            }
                                            value={data.services || null}
                                            onChange={(e, newValue) => {
                                            const updatedProducts = [...selectedProducts];
                                            updatedProducts[index].services = newValue;
                                            setSelectedProducts(updatedProducts);
                                            setRenderService(!renderService)
                                          }}
                                            getOptionLabel={(option) => `${option.description || ''} ${option.name || ''}`.trim()}
                                            renderOption={(props, option) => (
                                              <li {...props}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                  {option.syncWithQuickbooks == 1 && (
                                                    <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                                                  )}
                                                  <span>{`${option.description || ''} ${option.name || ''}`.trim()}</span>
                                                </Box>
                                              </li>
                                            )}
                                            renderInput={(params) => (
                                              <TextField {...params} label="Select Service (optional)" required fullWidth />
                                            )}
                                          />
                                        </TableCell>
                                        <TableCell colSpan={4}>
                                          {data.services ? (
                                            <TextField
                                              fullWidth
                                              type='number'
                                              label="Service Cost"
                                              value={data.services.total_cost || ''}
                                              onWheel={(e) => e.target.blur()}
                                              onFocus={selectInputValue}
                                              onClick={selectInputValue}
                                              onKeyPress={(event) => {
                                                if (event.key === '0' && event.target.value === '0') {
                                                  event.preventDefault();
                                                }
                                                if (event.key === '0' && event.target.value === '') {
                                                  event.preventDefault();
                                                }
                                                if (event.key === '-') {
                                                  event.preventDefault();
                                                }
                                              }}
                                              
                                            onKeyDown={(event) => {
                                              if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                                const newValue = event.target.value || 0;
                                                if (newValue < 1 && event.key === 'ArrowDown') {
                                                  event.preventDefault(); 
                                                }
                                              }
                                            }}
                                              onChange={(event) => {
                                                let newValue = event.target.value;
                                                if (newValue === "" || newValue === "0") {
                                                  newValue = "0";
                                                } else {
                                                  if (newValue.includes('.')) {
                                                    const parts = newValue.split('.');
                                                    if (parts[1].length > 2) {
                                                      newValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
                                                    }
                                                  }
                                                }
                                                const updatedProducts = [...selectedProducts];
                                                if (updatedProducts[index].services) {
                                                  updatedProducts[index].services.total_cost = newValue || 0;
                                                }
                                                setSelectedProducts(updatedProducts);
                                                
                                                // Recalculate sub_total
                                                let newTotalAmount = 0;
                                                updatedProducts.forEach(product => {
                                                  const totalUnits = (parseFloat(product?.quantity || 0) * parseFloat(product?.convertion_qty || 1));
                                                  const subtotal = (
                                                    (parseFloat(product?.unitCost || 0) * parseFloat(product?.quantity || 0)) +
                                                    // (parseFloat(product?.unitCost || 0) * totalUnits) +
                                                    (parseFloat(product?.shipping_cost || 0) * parseFloat(product?.quantity || 0)) +
                                                    parseFloat(product?.services?.total_cost || 0)
                                                  );
                                                  newTotalAmount += subtotal;
                                                });
                                                const fixedTotal = parseFloat(newTotalAmount).toFixed(2);
                                                setFieldValue('sub_total', Number(fixedTotal));
                                              }}
                                            />
                                          ) : (
                                            <Typography variant='body1'>No service selected</Typography>
                                          )}
                                        </TableCell>
                                      </TableRow>
                                    </>
                                    )}
                                      <TableRow>
                                        <TableCell colSpan={10} sx={{ padding: 0 }}>
                                          <Divider />
                                        </TableCell>
                                      </TableRow>
                                    </>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Scrollbar>
                      </>}

                {
                  productType == "stockCatalog" && (
                    <>

                      <LabelStyleHead>Stock Catalogs</LabelStyleHead>
                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, width: '100%' }}>
                          <Autocomplete
                            fullWidth
                            multiple
                            id="combo-box-demo"
                            options={
                              [...(stockCatalogs?.filter(product => !selectedStockCatalog.some(selected => selected.id === product.id)) || [])].sort((a, b) => {
                                const aValue =  a?.name || '';
                                const bValue =  b?.name || '';
                                return alphanumericCompare(aValue, bValue);
                              })
                            }
                            value={values.stockCatalogs}
                            onChange={async (event, newValue) => {
                              if (!newValue || newValue.length === 0) {
                                setFieldValue('stockCatalogs', newValue);
                                setSelectedStockCatalog([]);
                                setFieldValue('sub_total', 0);
                                setFieldValue('grand_total', 0);
                                setSearchCatalog('');
                                setQrCatalogSearchDisplayName('');
                              } else {
                                setFieldValue('stockCatalogs', newValue);
                                await handleStockCatalog(newValue);
                              }
                            }}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            getOptionLabel={(option) => {
                              const name = option.name || '';
                              const description = option.name || '';
                              return `${description} \u200B${name}`.trim(); // combines both for search
                            }}
                            renderOption={(props, option) => {
                              const { style, ...liProps } = props;
                              const description = option.name || '';
                              return (
                                <li
                                  {...liProps}
                                  style={{
                                    ...style,
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  {option.syncWithQuickbooks === 1 && (
                                    <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover", mr: 1 }}/>
                                  )}
                                  <Tooltip title={description}>
                                    <span style={{
                                      flex: 1,
                                      minWidth: 0,
                                      display: 'block',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                    }}>
                                      {description}
                                    </span>
                                  </Tooltip>
                                  <span style={{ display: 'none' }}>{option.name}</span>
                                </li>
                              );
                            }}
                            renderTags={(value, getTagProps) =>
                              value.map((option, index) => {
                                const tooltipText = `${option.name || ''}`;
                                return (
                                  <Tooltip key={index} title={tooltipText}>
                                    <Chip
                                      {...getTagProps({ index })}
                                      label={option.name || ''}
                                    />
                                  </Tooltip>
                                );
                              })
                            }
                            filterOptions={(options, { inputValue }) =>
                              options.filter((option) => {
                                const searchText = inputValue.toLowerCase();
                                return (
                                  option.description?.toLowerCase().includes(searchText) ||
                                  option.name?.toLowerCase().includes(searchText) 
                                );
                              })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                required
                                fullWidth
                                error={Boolean(touched.stockCatalogs && errors.stockCatalogs)}
                                helperText={touched.stockCatalogs && errors.stockCatalogs}
                                label="Select Catalog"
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      <Tooltip title="Scan QR Code">
                                        <IconButton
                                          size="small"
                                          onClick={() => setOpenCatalogQRScanner(true)}
                                          sx={{ mr: 1 }}
                                        >
                                          <QrCodeScanner />
                                        </IconButton>
                                      </Tooltip>
                                      {params.InputProps.endAdornment}
                                    </>
                                  )
                                }}
                              />
                            )}
                          />
                          <Dialog open={openCatalogQRScanner} onClose={() => setOpenCatalogQRScanner(false)}>
                            <DialogTitle>Scan QR Code</DialogTitle>
                            <DialogContent>
                              <div id="reader" style={{ width: "100%" }}></div>
                            </DialogContent>
                          </Dialog>
                        </Box>
                      </Stack>
                      </>
                    )
                     }

                      {(selectedStockCatalog?.length > 0) &&
                      <>
                        <LabelStyle>Selected Catalogs</LabelStyle>
                        <Scrollbar>
                          <TableContainer sx={{ minWidth: 800 }}>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  {VALUEStockCatalog?.map((val) => (
                                    <TableCell key={val.id}>{val.value}</TableCell>
                                  ))}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {selectedStockCatalog?.map((data, index) => {
                                  const quantityFieldName = `quantity_${index}`;
                                  const unitCostFieldName = `unitCost_${index}`;
                                  const shippingFieldName = `shipping_cost_${index}`;
                                  const rowTotal = (
                                  (parseFloat(data?.unitCost || 0) * parseFloat(data?.quantity || 0)) +
                                  (parseFloat(data?.shipping_cost || 0) * parseFloat(data?.quantity || 0)) +
                                  parseFloat(data?.services?.total_cost || 0)
                                ).toFixed(2);
                                  // Accumulate the totalAmount
                                  totalAmount += Number(rowTotal);
                                  const fixedTotal = parseFloat(totalAmount).toFixed(2);
                                  // setFieldValue('sub_total', fixedTotal);
                                  values['sub_total'] = fixedTotal
                                  console.log(data,'-----------data')
                                  return (
                                    <>
                                    <TableRow key={data.id}>
                                      <TableCell sx={{ maxWidth: 200, wordBreak: 'break-word', verticalAlign: 'top' }}>
                                        {data.name || ''}
                                      </TableCell>
                                      <TableCell sx={{ maxWidth: 280, wordBreak: 'break-word', verticalAlign: 'top' }}>
                                        {data.description || ''}
                                      </TableCell>
                                      <TableCell>
                                        <TextField required
                                          fullWidth
                                          type='number'
                                          label="QTY ORDERED"
                                          value={data.quantity || ''}
                                          onWheel={(e) => e.target.blur()}
                                          onKeyPress={(event) => {
                                            if (event.key === '0' && event.target.value === '0' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '0' && event.target.value === '' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '.' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '-' ) {
                                              event.preventDefault();
                                            }
                                          }}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (newValue !== "0" && newValue !== "") {
                                              if (newValue.startsWith('-')) {
                                                newValue = newValue.slice(1);
                                              }
                                              data['quantity'] = newValue || 0;
                                              setFieldValue(quantityFieldName, newValue);
                                              let newTotalAmount = 0;
                                              selectedProducts.forEach(product => {
                                                const subtotal = (
                                                  (parseFloat(product?.unitCost || 0) * parseFloat(product?.quantity || 0)) +
                                                  (parseFloat(product?.shipping_cost || 0) * parseFloat(product?.quantity || 0)) +
                                                  parseFloat(product?.services?.total_cost || 0)
                                                );
                                                newTotalAmount += subtotal;
                                              });
                                              selectedStockCatalog.forEach(catalog => {
                                                const subtotal = (
                                                  (parseFloat(catalog?.unitCost || 0) * parseFloat(catalog?.quantity || 0)) +
                                                  (parseFloat(catalog?.shipping_cost || 0) * parseFloat(catalog?.quantity || 0)) +
                                                  parseFloat(catalog?.services?.total_cost || 0)
                                                );
                                                newTotalAmount += subtotal;
                                              });
                                              setFieldValue('sub_total', parseFloat(newTotalAmount).toFixed(2));
                                            }
                                          }}
                                          error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                          helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <TextField required
                                          fullWidth
                                          type='number'
                                          label="UNIT COST"
                                          sx={{width:"100px"}}
                                          value={data.unitCost || ''}
                                          onKeyPress={(event) => {
                                            if (event.key === '0' && event.target.value === '0' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '0' && event.target.value === '' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '-' ) {
                                              event.preventDefault();
                                            }
                                          }}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (newValue !== "0" && newValue !== "") {
                                              if (newValue.includes('.')) {
                                                const parts = newValue.split('.');
                                                if (parts[1].length > 2) {
                                                    newValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
                                                }
                                            }
                                              data['unitCost'] = newValue || 0;
                                              setFieldValue(unitCostFieldName, newValue);
                                              let newTotalAmount = 0;
                                              selectedProducts.forEach(product => {
                                                const subtotal = (
                                                  (parseFloat(product?.unitCost || 0) * parseFloat(product?.quantity || 0)) +
                                                  (parseFloat(product?.shipping_cost || 0) * parseFloat(product?.quantity || 0)) +
                                                  parseFloat(product?.services?.total_cost || 0)
                                                );
                                                newTotalAmount += subtotal;
                                              });
                                              selectedStockCatalog.forEach(catalog => {
                                                const subtotal = (
                                                  (parseFloat(catalog?.unitCost || 0) * parseFloat(catalog?.quantity || 0)) +
                                                  (parseFloat(catalog?.shipping_cost || 0) * parseFloat(catalog?.quantity || 0)) +
                                                  parseFloat(catalog?.services?.total_cost || 0)
                                                );
                                                newTotalAmount += subtotal;
                                              });
                                              setFieldValue('sub_total', parseFloat(newTotalAmount).toFixed(2));
                                            }
                                          }}
                                          error={Boolean(touched[unitCostFieldName] && errors[unitCostFieldName])}
                                          helperText={touched[unitCostFieldName] && errors[unitCostFieldName]}
                                        />
                                      </TableCell>
                                      <TableCell align="center">-</TableCell>
                                      <TableCell align="center">-</TableCell>
                                      <TableCell sx={{ minWidth: 250 }}>
                                        <Autocomplete
                                          fullWidth
                                          id={`sub-catalog-autocomplete-${data.id}`}
                                          options={
                                            [...(serviceData || [])].sort((a, b) => {
                                              const aValue = a?.description || a?.name || '';
                                              const bValue = b?.description || b?.name || '';
                                              return alphanumericCompare(aValue, bValue);
                                            })
                                          }
                                          value={data.services || null}
                                          onChange={(e, newValue) => {
                                            const updatedProducts = [...selectedStockCatalog];
                                            updatedProducts[index].services = newValue;
                                            setSelectedStockCatalog(updatedProducts);
                                            setRenderService(!renderService);
                                            let newTotalAmount = 0;
                                            selectedProducts.forEach(product => {
                                              const subtotal = (
                                                (parseFloat(product?.unitCost || 0) * parseFloat(product?.quantity || 0)) +
                                                (parseFloat(product?.shipping_cost || 0) * parseFloat(product?.quantity || 0)) +
                                                parseFloat(product?.services?.total_cost || 0)
                                              );
                                              newTotalAmount += subtotal;
                                            });
                                            updatedProducts.forEach(catalog => {
                                              const subtotal = (
                                                (parseFloat(catalog?.unitCost || 0) * parseFloat(catalog?.quantity || 0)) +
                                                (parseFloat(catalog?.shipping_cost || 0) * parseFloat(catalog?.quantity || 0)) +
                                                parseFloat(catalog?.services?.total_cost || 0)
                                              );
                                              newTotalAmount += subtotal;
                                            });
                                            setFieldValue('sub_total', parseFloat(newTotalAmount).toFixed(2));
                                          }}
                                          getOptionLabel={(option) => `${option.description || ''} ${option.name || ''}`.trim()}
                                          renderOption={(props, option) => (
                                            <li {...props}>
                                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                {option.syncWithQuickbooks == 1 && (
                                                  <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                                                )}
                                                <span>{`${option.description || ''} ${option.name || ''}`.trim()}</span>
                                              </Box>
                                            </li>
                                          )}
                                          renderInput={(params) => (
                                            <TextField {...params} label="Select Service (optional)" required fullWidth />
                                          )}
                                        />
                                      </TableCell>
                                      <TableCell sx={{ width: 112, maxWidth: 120, verticalAlign: 'middle' }}>
                                        {data.services ? (
                                          <TextField
                                            type='number'
                                            label="Service Cost"
                                            sx={{ width: 104, maxWidth: 110 }}
                                            value={data.services.total_cost || ''}
                                            onWheel={(e) => e.target.blur()}
                                            onKeyPress={(event) => {
                                              if (event.key === '0' && event.target.value === '0') {
                                                event.preventDefault();
                                              }
                                              if (event.key === '0' && event.target.value === '') {
                                                event.preventDefault();
                                              }
                                              if (event.key === '-') {
                                                event.preventDefault();
                                              }
                                            }}
                                            onKeyDown={(event) => {
                                              if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                                const newValue = event.target.value || 0;
                                                if (newValue < 1 && event.key === 'ArrowDown') {
                                                  event.preventDefault();
                                                }
                                              }
                                            }}
                                            onChange={(event) => {
                                              let newValue = event.target.value;
                                              if (newValue === "" || newValue === "0") {
                                                newValue = "0";
                                              } else {
                                                if (newValue.includes('.')) {
                                                  const parts = newValue.split('.');
                                                  if (parts[1].length > 2) {
                                                    newValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
                                                  }
                                                }
                                              }
                                              const updatedCatalogs = [...selectedStockCatalog];
                                              if (updatedCatalogs[index].services) {
                                                updatedCatalogs[index].services.total_cost = newValue || 0;
                                              }
                                              setSelectedStockCatalog(updatedCatalogs);
                                              let newTotalAmount = 0;
                                              selectedProducts.forEach(product => {
                                                const subtotal = (
                                                  (parseFloat(product?.unitCost || 0) * parseFloat(product?.quantity || 0)) +
                                                  (parseFloat(product?.shipping_cost || 0) * parseFloat(product?.quantity || 0)) +
                                                  parseFloat(product?.services?.total_cost || 0)
                                                );
                                                newTotalAmount += subtotal;
                                              });
                                              updatedCatalogs.forEach(catalog => {
                                                const subtotal = (
                                                  (parseFloat(catalog?.unitCost || 0) * parseFloat(catalog?.quantity || 0)) +
                                                  (parseFloat(catalog?.shipping_cost || 0) * parseFloat(catalog?.quantity || 0)) +
                                                  parseFloat(catalog?.services?.total_cost || 0)
                                                );
                                                newTotalAmount += subtotal;
                                              });
                                              const fixedTotal = parseFloat(newTotalAmount).toFixed(2);
                                              setFieldValue('sub_total', Number(fixedTotal));
                                            }}
                                          />
                                        ) : (
                                          <Typography variant='body1'>No service selected</Typography>
                                        )}
                                      </TableCell>
                                      <TableCell>
                                        {rowTotal}
                                      </TableCell>
                                      <TableCell >
                                        <IconButton onClick={() => handleDeleteProduct(data.id,0)}>
                                          <Delete />
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>
                                    {/* Previous stock catalog table (two-row layout). Disabled — remove `false &&` to render again. */}
                                    {false && (
                                    <>
                                    <TableRow key={`legacy-catalog-row-${data.id}`}>
                                      <TableCell>{data.id}</TableCell>
                                      <TableCell>{data.name}</TableCell>
                                      <TableCell>
                                        <TextField required
                                          fullWidth
                                          type='number'
                                          label="Unit Cost"
                                          sx={{width:"100px"}}
                                          value={data.unitCost || ''}
                                          onFocus={selectInputValue}
                                          onClick={selectInputValue}
                                          onKeyPress={(event) => {
                                            // console.log('errorFieldId------',errorFieldId)
                                            if (event.key === '0' && event.target.value === '0' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '0' && event.target.value === '' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '-' ) {
                                              event.preventDefault();
                                            }
                                          }}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (newValue !== "0" && newValue !== "") {

                                              if (newValue.includes('.')) {
                                                const parts = newValue.split('.');
                                                if (parts[1].length > 2) {
                                                    newValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
                                                }
                                            }

                                              data['unitCost'] = newValue || 0;
                                              setFieldValue(unitCostFieldName, newValue);
                                            }
                                          
                                          }}
                                          error={Boolean(touched[unitCostFieldName] && errors[unitCostFieldName])}
                                          helperText={touched[unitCostFieldName] && errors[unitCostFieldName]}
                                        />
                                      </TableCell>
                                        <TableCell align='center'>{data.total_qty}</TableCell>  
                                      <TableCell>
                                        <TextField required
                                          fullWidth
                                          type='number'
                                          label="Quantity"
                                          value={data.quantity || ''}
                                          onWheel={(e) => e.target.blur()}
                                          onFocus={selectInputValue}
                                          onClick={selectInputValue}
                                          onKeyPress={(event) => {
                                            // console.log('errorFieldId------',errorFieldId)
                                            if (event.key === '0' && event.target.value === '0' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '0' && event.target.value === '' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '.' ) {
                                              event.preventDefault();
                                            }
                                            if (event.key === '-' ) {
                                              event.preventDefault();
                                            }
                                          }}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (newValue !== "0" && newValue !== "") {
                                              if (newValue.startsWith('-')) {
                                                newValue = newValue.slice(1);
                                              }
                                              data['quantity'] = newValue || 0;
                                              setFieldValue(quantityFieldName, newValue);
                                            }
                                          }}
                                          error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                          helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                        />
                                      </TableCell>
                                      {/* <TableCell>
                                        <TextField required
                                          fullWidth
                                          type='number'
                                          label="Shipping"
                                          value={data?.shipping_cost || ''}
                                          onWheel={(e) => e.target.blur()}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (newValue !== "0" && newValue !== "") {
                                              if (newValue.startsWith('-')) {
                                                newValue = newValue.slice(1);
                                              }
                                              data['shipping_cost'] = newValue || 0;
                                              setFieldValue(shippingFieldName, newValue);
                                            }
                                          }}
                                          error={Boolean(touched[shippingFieldName] && errors[shippingFieldName])}
                                          helperText={touched[shippingFieldName] && errors[shippingFieldName]}
                                        />
                                      </TableCell> */}
                                      <TableCell> 
                                        {rowTotal}
                                      </TableCell>
                                      <TableCell >
                                        <IconButton onClick={() => handleDeleteProduct(data.id,0)}>
                                          <Delete />
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>
                                    <TableRow key={`sub-catalog-${data.id}`}>
                                        <TableCell colSpan={3}>
                                          <Autocomplete
                                            fullWidth
                                            id={`sub-catalog-autocomplete-legacy-${data.id}`}
                                            options={
                                              [...(serviceData || [])].sort((a, b) => {
                                                const aValue = a?.description || a?.name || '';
                                                const bValue = b?.description || b?.name || '';
                                                return alphanumericCompare(aValue, bValue);
                                              })
                                            }
                                            value={data.services || null}
                                            onChange={(e, newValue) => {
                                            const updatedProducts = [...selectedStockCatalog];
                                            updatedProducts[index].services = newValue;
                                            setSelectedStockCatalog(updatedProducts);
                                            setRenderService(!renderService)
                                          }}
                                            getOptionLabel={(option) => `${option.description || ''} ${option.name || ''}`.trim()}
                                            renderOption={(props, option) => (
                                              <li {...props}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                  {option.syncWithQuickbooks == 1 && (
                                                    <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                                                  )}
                                                  <span>{`${option.description || ''} ${option.name || ''}`.trim()}</span>
                                                </Box>
                                              </li>
                                            )}
                                            renderInput={(params) => (
                                              <TextField {...params} label="Select Service (optional)" required fullWidth />
                                            )}
                                          />
                                        </TableCell>
                                        <TableCell colSpan={4}>
                                          {data.services ? (
                                            <TextField
                                              sx={{width:"200px"}}
                                              type='number'
                                              label="Service Cost"
                                              value={data.services.total_cost || ''}
                                              onWheel={(e) => e.target.blur()}
                                              onFocus={selectInputValue}
                                              onClick={selectInputValue}
                                              onKeyPress={(event) => {
                                                if (event.key === '0' && event.target.value === '0') {
                                                  event.preventDefault();
                                                }
                                                if (event.key === '0' && event.target.value === '') {
                                                  event.preventDefault();
                                                }
                                                if (event.key === '-') {
                                                  event.preventDefault();
                                                }
                                              }}
                                              
                                            onKeyDown={(event) => {
                                              if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                                const newValue = event.target.value || 0;
                                                if (newValue < 1 && event.key === 'ArrowDown') {
                                                  event.preventDefault(); 
                                                }
                                              }
                                            }}
                                              onChange={(event) => {
                                                let newValue = event.target.value;
                                                if (newValue === "" || newValue === "0") {
                                                  newValue = "0";
                                                } else {
                                                  if (newValue.includes('.')) {
                                                    const parts = newValue.split('.');
                                                    if (parts[1].length > 2) {
                                                      newValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
                                                    }
                                                  }
                                                }
                                                const updatedCatalogs = [...selectedStockCatalog];
                                                if (updatedCatalogs[index].services) {
                                                  updatedCatalogs[index].services.total_cost = newValue || 0;
                                                }
                                                setSelectedStockCatalog(updatedCatalogs);
                                                
                                                // Recalculate sub_total
                                                let newTotalAmount = 0;
                                                updatedCatalogs.forEach(catalog => {
                                                  const subtotal = (
                                                    (parseFloat(catalog?.unitCost || 0) * parseFloat(catalog?.quantity || 0)) +
                                                    (parseFloat(catalog?.shipping_cost || 0) * parseFloat(catalog?.quantity || 0)) +
                                                    parseFloat(catalog?.services?.total_cost || 0)
                                                  );
                                                  newTotalAmount += subtotal;
                                                });
                                                const fixedTotal = parseFloat(newTotalAmount).toFixed(2);
                                                setFieldValue('sub_total', Number(fixedTotal));
                                              }}
                                            />
                                          ) : (
                                            <Typography variant='body1'>No service selected</Typography>
                                          )}
                                        </TableCell>
                                      </TableRow>
                                    </>
                                    )}
                                      <TableRow>
                                        <TableCell colSpan={10} sx={{ padding: 0 }}>
                                          <Divider />
                                        </TableCell>
                                      </TableRow>
                                    </>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Scrollbar>
                      </>}

                      {
                        productType == "serviceOnly" && (
                          <>
                            <LabelStyleHead>Services</LabelStyleHead>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, width: '100%' }}>
                                <Autocomplete
                                  fullWidth
                                  multiple
                                  id="service-autocomplete"
                                  options={
                                    [...(serviceData?.filter(service => !selectedServices.some(selected => selected.id === service.id)) || [])].sort((a, b) => {
                                      const aValue = a?.description || a?.name || '';
                                      const bValue = b?.description || b?.name || '';
                                      return alphanumericCompare(aValue, bValue);
                                    })
                                  }
                                  value={values.services}
                                  onChange={(event, newValue) => {
                                    if (!newValue || newValue.length === 0) {
                                      setFieldValue('services', newValue);
                                      setSelectedServices([]);
                                      setFieldValue('sub_total', 0);
                                      setFieldValue('grand_total', 0);
                                    } else {
                                      setFieldValue('services', newValue);
                                      handleService(newValue);
                                    }
                                  }}
                                  isOptionEqualToValue={(option, value) => option.id === value.id}
                                  getOptionLabel={(option) => `${option.description || ''} ${option.name || ''}`.trim()}
                                  renderOption={(props, option) => (
                                    <li {...props}>
                                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        {option.syncWithQuickbooks == 1 && (
                                          <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                                        )}
                                        <span>{`${option.description || ''} ${option.name || ''}`.trim()}</span>
                                      </Box>
                                    </li>
                                  )}
                                  renderTags={(value, getTagProps) =>
                                    value.map((option, index) => {
                                      const tooltipText = `${option.description || ''} ${option.name || ''}`.trim();
                                      return (
                                        <Tooltip key={index} title={tooltipText}>
                                          <Chip
                                            {...getTagProps({ index })}
                                            label={`${option.description || ''} ${option.name || ''}`.trim()}
                                          />
                                        </Tooltip>
                                      );
                                    })
                                  }
                                  filterOptions={(options, { inputValue }) =>
                                    options.filter((option) => {
                                      const searchText = inputValue.toLowerCase();
                                      return (
                                        option.name?.toLowerCase().includes(searchText) ||
                                        option.description?.toLowerCase().includes(searchText)
                                      );
                                    })
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      required
                                      fullWidth
                                      error={Boolean(touched.services && errors.services)}
                                      helperText={touched.services && errors.services}
                                      label="Select Services"
                                    />
                                  )}
                                />
                              </Box>
                            </Stack>
                          </>
                        )
                      }

                      {(selectedServices?.length > 0) &&
                      <>
                        <LabelStyle>Selected Services</LabelStyle>
                        <Scrollbar>
                          <TableContainer sx={{ minWidth: 800 }}>
                            <Table>
                              <TableHead>
                                <TableRow>
                                {/* <TableCell>Service ID</TableCell>
                                  <TableCell>Service Name</TableCell>
                                  <TableCell>Price</TableCell> */}
                                  <TableCell align="center">#</TableCell>
                                  <TableCell align="center">SERVICES</TableCell>
                                  <TableCell align="center">TOTAL COST</TableCell>
                                  <TableCell align="center" sx={{ width: 80 }} />
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {selectedServices?.map((data, index) => {
                                  const priceFieldName = `service_price_${index}`;
                                  return (
                                    <>
                                      <TableRow key={data.id}>
                                        <TableCell align="center">{index + 1}</TableCell>
                                        <TableCell align="center">{data.description || data.name}</TableCell>
                                        <TableCell align="center" sx={{ verticalAlign: 'middle' }}>
                                          <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                                          <TextField
                                            required
                                            type='number'
                                            label="TOTAL COST"
                                            sx={{ width: 104, maxWidth: 110 }}
                                            value={data.total_cost || ''}
                                            onWheel={(e) => e.target.blur()}
                                            onKeyPress={(event) => {
                                              if (event.key === '0' && event.target.value === '0') {
                                                event.preventDefault();
                                              }
                                              if (event.key === '0' && event.target.value === '') {
                                                event.preventDefault();
                                              }
                                              if (event.key === '-') {
                                                event.preventDefault();
                                              }
                                            }}
                                            onKeyDown={(event) => {
                                              if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                                const newValue = event.target.value || 0;
                                                if (newValue < 1 && event.key === 'ArrowDown') {
                                                  event.preventDefault();
                                                }
                                              }
                                            }}
                                            onChange={(event) => {
                                              let newValue = event.target.value;
                                              if (newValue === "" || newValue === "0") {
                                                newValue = "0";
                                              } else {
                                                if (newValue.includes('.')) {
                                                  const parts = newValue.split('.');
                                                  if (parts[1].length > 2) {
                                                    newValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
                                                  }
                                                }
                                              }
                                              const updatedServices = [...selectedServices];
                                              updatedServices[index].total_cost = newValue || 0;
                                              setSelectedServices(updatedServices);

                                              let newTotalAmount = 0;
                                              updatedServices.forEach(service => {
                                                newTotalAmount += parseFloat(service?.total_cost || 0);
                                              });
                                              const fixedTotal = parseFloat(newTotalAmount).toFixed(2);
                                              setFieldValue('sub_total', Number(fixedTotal));
                                            }}
                                            error={Boolean(touched[priceFieldName] && errors[priceFieldName])}
                                            helperText={touched[priceFieldName] && errors[priceFieldName]}
                                          />
                                          </Box>
                                        </TableCell>
                                        <TableCell align="center" sx={{ width: 80, pl: 2, pr: 1 }}>
                                          <IconButton onClick={() => handleDeleteProduct(data.id, 2)}>
                                            <Delete />
                                          </IconButton>
                                        </TableCell>
                                      </TableRow>
                                      {/* Previous Selected Services row (Service ID / Service Name / Price). Disabled — remove `false &&` to render again. */}
                                      {false && (
                                      <TableRow key={`legacy-service-row-${data.id}`}>
                                        <TableCell>{data.id}</TableCell>
                                        <TableCell>{data.description || data.name}</TableCell>
                                        <TableCell>
                                          <TextField
                                            required
                                            fullWidth
                                            type='number'
                                            label="Price"
                                            sx={{width:"200px"}}
                                            value={data.total_cost || ''}
                                            onWheel={(e) => e.target.blur()}
                                            onFocus={selectInputValue}
                                            onClick={selectInputValue}
                                            onKeyPress={(event) => {
                                              if (event.key === '0' && event.target.value === '0') {
                                                event.preventDefault();
                                              }
                                              if (event.key === '0' && event.target.value === '') {
                                                event.preventDefault();
                                              }
                                              if (event.key === '-') {
                                                event.preventDefault();
                                              }
                                            }}
                                            onKeyDown={(event) => {
                                              if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                                const newValue = event.target.value || 0;
                                                if (newValue < 1 && event.key === 'ArrowDown') {
                                                  event.preventDefault(); 
                                                }
                                              }
                                            }}
                                            onChange={(event) => {
                                              let newValue = event.target.value;
                                              if (newValue === "" || newValue === "0") {
                                                newValue = "0";
                                              } else {
                                                if (newValue.includes('.')) {
                                                  const parts = newValue.split('.');
                                                  if (parts[1].length > 2) {
                                                    newValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
                                                  }
                                                }
                                              }
                                              const updatedServices = [...selectedServices];
                                              updatedServices[index].total_cost = newValue || 0;
                                              setSelectedServices(updatedServices);
                                              
                                              // Recalculate sub_total
                                              let newTotalAmount = 0;
                                              updatedServices.forEach(service => {
                                                newTotalAmount += parseFloat(service?.total_cost || 0);
                                              });
                                              const fixedTotal = parseFloat(newTotalAmount).toFixed(2);
                                              setFieldValue('sub_total', Number(fixedTotal));
                                            }}
                                            error={Boolean(touched[priceFieldName] && errors[priceFieldName])}
                                            helperText={touched[priceFieldName] && errors[priceFieldName]}
                                          />
                                        </TableCell>
                                        <TableCell>
                                          <IconButton onClick={() => handleDeleteProduct(data.id, 2)}>
                                            <Delete />
                                          </IconButton>
                                        </TableCell>
                                      </TableRow>
                                      )}
                                      <TableRow>
                                        <TableCell colSpan={4} sx={{ padding: 0 }}>
                                          <Divider />
                                        </TableCell>
                                      </TableRow>
                                    </>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Scrollbar>
                      </>}

                     
                      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between' }}>
                        

                          <Autocomplete
                              // sx={{ width: 400 }}
                              fullWidth
                              id="combo-box-demo"
                              options={taxCategories || []}
                              value={selectedTaxCategory || null}
                              onChange={(event, newValue) => {
                                handleTaxCategoryChange(newValue)
                                setSelectedTaxCategory(newValue);
                              }}
                              renderInput={(params) => (
                                <TextField {...params} label="Select tax category" />
                              )}
                              getOptionLabel={(option) => option.name ? option.name : ''}
                            />
                      </Box>

                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                        <TextField
                          fullWidth
                          label="Sub Total"
                          {...getFieldProps('sub_total')}
                          error={Boolean(touched.sub_total && errors.sub_total)}
                          helperText={touched.sub_total && errors.sub_total}
                          InputLabelProps={{ style: { color: theme.palette.text.primary } }}
                          InputProps={{ readOnly:true }}
                        />
                        <TextField
                          fullWidth
                          label="Tax"
                          {...getFieldProps('tax')}
                          error={Boolean(touched.tax && errors.tax)}
                          helperText={touched.tax && errors.tax}
                          InputLabelProps={{ style: { color: theme.palette.text.primary } }}
                          InputProps={{ readOnly:true }}
                        />
                        <TextField
                          fullWidth
                          label="Grand Total"
                          {...getFieldProps('grand_total')}
                          error={Boolean(touched.grand_total && errors.grand_total)}
                          helperText={touched.grand_total && errors.grand_total}
                          InputLabelProps={{ style: { color: theme.palette.text.primary } }}
                          InputProps={{ readOnly:true }}
                        />
                      </Stack>

                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                      <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                        Create Order
                      </LoadingButton>
                      <Button variant="outlined" onClick={handleback} sx={{ marginLeft: '10px' }}>
                        Cancel
                      </Button>
                    </Box>
                  </Stack>
                </Card>
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </Container>

      {/* Auto-save confirmation dialog */}
      <Dialog
        open={openBackConfirm}
        onClose={() => setOpenBackConfirm(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Go back?</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Do you want to auto save this order before going back?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleBackConfirmNo} variant="outlined" color="primary">
            No, Go Back
          </Button>
          <Button onClick={handleBackConfirmYes} variant="contained" color="primary">
            Yes, Auto Save
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}